import { useQuery } from '@tanstack/react-query';
import { fetchDashboard } from './api';

/**
 * Query keys as a factory, so invalidation stays sane as features multiply.
 * `dashboardKeys.all` invalidates every window at once — which is what you
 * want after a sale, because you do not know which window the user is on.
 */
export const dashboardKeys = {
  all: ['dashboard'] as const,
  window: (days: number, outletId?: number | 'all') =>
    [...dashboardKeys.all, days, outletId ?? 'active'] as const,
};

export function useDashboard(days: number, outletId?: number | 'all') {
  return useQuery({
    queryKey: dashboardKeys.window(days, outletId),
    queryFn: () => fetchDashboard({ days, outlet_id: outletId }),

    // The server already caches this for a minute. Matching that here stops
    // a range toggle from re-fetching something the API will hand back
    // unchanged anyway.
    staleTime: 60_000,

    // Keeps the previous window on screen while a new one loads, so toggling
    // 7/30/90 days moves the numbers rather than blanking the page.
    placeholderData: (previous) => previous,
  });
}
